import { RouterStateSnapshot } from '@angular/router';
import { AUTH_ROUTES } from '../constants/auth.constants';

export class RouteUtils {
    static isPasswordResetRoute(state: RouterStateSnapshot): boolean {
        return (
            state.url.includes(AUTH_ROUTES.PASSWORD) ||
            window.location.pathname.includes(AUTH_ROUTES.PASSWORD) ||
            state.url.includes(AUTH_ROUTES.RESET_PASSWORD) ||
            window.location.pathname.includes(AUTH_ROUTES.RESET_PASSWORD) ||
            window.location.pathname === AUTH_ROUTES.PASSWORD
        );
    }

    static isInviteRoute(state: RouterStateSnapshot): boolean {
        return (
            state.url.includes(AUTH_ROUTES.INVITE) ||
            window.location.pathname.includes(AUTH_ROUTES.INVITE) ||
            window.location.pathname === AUTH_ROUTES.INVITE
        );
    }

    static isOnSigninPage(state: RouterStateSnapshot): boolean {
        return state.url.includes(AUTH_ROUTES.SIGNIN) ||
            window.location.pathname.includes(AUTH_ROUTES.SIGNIN);
    }

    static isNonSigninAuthPage(state: RouterStateSnapshot): boolean {
        return state.url.includes(AUTH_ROUTES.AUTH_PREFIX) &&
            !state.url.includes(AUTH_ROUTES.SIGNIN);
    }

    static shouldRedirectToAuth(state: RouterStateSnapshot): boolean {
        return (
            !state.url ||
            state.url.length === 0 ||
            state.url === '' ||
            state.url === '/' ||
            window.location.pathname === '/' ||
            state.url.includes(AUTH_ROUTES.AUTH_PREFIX)
        );
    }
}